import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { ComunaService } from 'src/app/services/comuna.service';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import * as _ from 'lodash';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { ImprimirFacturaDetalleComponent } from './modal-detalle/modal-imprimir-factura-detalle.component';
import { ImprimirFacturaResultadoComponent } from './modal-resultado/modal-imprimir-factura-resultado.component';
import { ToastService } from 'ng-uikit-pro-standard';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { debounceTime, filter } from 'rxjs/operators';
import { IOperacionPermitidaQueryParams, RolOperacionService } from 'src/app/services/rol-operacion.service';

@Component({
  selector: 'app-imprimir-factura',
  templateUrl: './imprimir-factura.component.html',
  styleUrls: ['./imprimir-factura.component.scss'],
  providers: [SecurityService],
})
export class ImprimirFacturaComponent implements OnInit {
  // Form
  formHeader: FormGroup;

  // Data & tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;
  private rutUsuario: number;
  private currentPayload: any = null;
  loading: boolean = false;
  processing: boolean = false;
  paginationContext: PaginationContext = new PaginationContext();
  optionsRecorrido: Array<any> = [];
  optionsTipoDoc: Array<any> = [];
  optionsVendedor: Array<any> = [];
  optionsComunas: Array<any> = [];
  optionsOrderImpresion: Array<any> = [];
  camion: string = '';
  chofer: string = '';
  listaMovimientosAll: Array<any> = null;
  listaMovimientos: Array<any> = null;
  docSeleccionado: number;
  loadSpinner: boolean = false;
  visualizarLimpiadorImp: boolean = false;
  // Utils
  private log: any;

  //Modales
  @ViewChild(ImprimirFacturaDetalleComponent, { static: true }) modalSeleccionarImprimirFacturaDetalle: ImprimirFacturaDetalleComponent;
  @ViewChild(ImprimirFacturaResultadoComponent, { static: true }) modalSeleccionarImprimirFacturaResultado: ImprimirFacturaResultadoComponent;
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  cliente: any = null;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private tipoDTEService: TipoDTEService,
    private vendedorService: VendedorService,
    private comunasService: ComunaService,
    private recorridoService: RecorridoService,
    private datesService: DatesService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private documentoService: DocumentoService,
    private fileDownloadService: FileDownloadService,
    private toastService: ToastService,
    private rolOperacionService: RolOperacionService
  ) {
    this.log = this.clog.log('IMPRIMIR FACTURA');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
    this.paginationContext.RecordsByPage = 10;
    this.createForm();

    this.optionsOrderImpresion = [
      { value: '1', label: 'Documento + Folio' },
      { value: '2', label: 'Cliente' },
      { value: '3', label: 'Secuencia' },
      { value: '4', label: 'Ruta' },
      { value: '5', label: 'Comuna' },
    ];
    this.loadRecorridos();
    this.loadPermiteLimpiarImpresiones();
    this.loadTipoDoc();
    this.loadVendedor();
    this.formChangesSubscriptions();
  }

  formChangesSubscriptions() {
    this.formHeader.get('listaRecorridos').valueChanges.subscribe((recorrido: Number) => {
      if (this.optionsRecorrido.filter((p) => p.value === recorrido)[0] != undefined) {
        this.camion = this.optionsRecorrido.filter((p) => p.value === recorrido)[0].camionPatente;
        this.chofer = this.optionsRecorrido.filter((p) => p.value === recorrido)[0].choferNombre;
      }

      if (recorrido) this.handleChangeTipoDocumento(recorrido);
    });
    this.formHeader.get('fechaDesde').valueChanges.subscribe((fdesde) => {
      this.loadRecorridos();
    });

    this.formHeader.get('fechaHasta').valueChanges.subscribe((fhasta) => {
      this.loadRecorridos();
    });
    this.formHeader.get('orden_envio').valueChanges.subscribe((order) => {
      this.buscar(1);
    });

    this.formHeader
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
      });
  }

  handleChangeTipoDocumento(recorrido) {
    if (recorrido === -1 || recorrido === -2) {
      this.formHeader.get('listaTipoDoc').enable();
    } else {
      this.formHeader.get('listaTipoDoc').disable();
      this.formHeader.get('listaTipoDoc').setValue([]);
    }
  }

  private loadRecorridos() {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: this.formHeader.get('fechaDesde').value,
        fecha_hasta: this.formHeader.get('fechaHasta').value,
      },
    };
    this.recorridoService.obtenerRecorridos(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsRecorrido = registros.map((recorrido) => ({
        value: recorrido.codigo,
        label: recorrido.codigo === -1 ? 'Todos' : recorrido.codigo === -2 ? 'Sin Recorrido' : recorrido.codigo,
        camionPatente: recorrido.camion_patente,
        choferNombre: recorrido.nombreChofer,
        ...recorrido,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaRecorridos'), this.optionsRecorrido);
    });
  }

  private loadTipoDoc() {
    // Tipos documentos
    this.tipoDTEService.GetByTipoDte(5, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsTipoDoc = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
      //this.setDefaultDoctoReferencia()
    });
  }

  private loadVendedor() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalCodigo, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsVendedor = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
    });
  }

  private loadPermiteLimpiarImpresiones() {
    const inputParams: IOperacionPermitidaQueryParams = {
      rut_usu: this.rutUsuario,
      codgo_modulo: 36,
      cod_operacion: 21,
    };

    this.rolOperacionService.operacionPermitida(inputParams, (allowed) => {
      this.visualizarLimpiadorImp = allowed;
    });
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      fechaDesde: [currentDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      rutCliente: [null, []],
      nroDoc: [null, []],
      listaRecorridos: [[]],
      listaTipoDoc: [[]],
      documento: [true],
      copia_cedible: [true],
      enviar_pdf: [true],
      enviar_xml: [true],
      orden_envio: [0],
      listaVendedor: [[]],
      listaComunas: [[]],
    });
  }

  limpiarImpresionTablasLsof() {
    this.loadSpinner = true;
    const inputParams = {
      entidad: { rut_emisor: this.rutEmpresa },
    };
    this.documentoService.limpiarImpresionTablasLsof(inputParams, ({ respuesta }) => {
      console.log(respuesta);
      const ok = respuesta !== null;
      if (!ok) {
        this.toastService.error('Error al limpiar impresiones');
        this.loadSpinner = false;
        return;
      }
      this.toastService.success('Se han limpiado las impresiones exitosamente');
      this.loadSpinner = false;
    });
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      return;
    }

    this.paginationContext.CurrentPage = pageNumber;

    //this.listaMovimientos = []
    //this.listaMovimientosAll = []

    const { fechaDesde, fechaHasta, listaRecorridos, listaTipoDoc, listaVendedor, listaComunas, orden_envio, rutCliente, nroDoc } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: nroDoc === null ? fechaDesde : null,
        fecha_hasta: nroDoc === null ? fechaHasta : null,
        cliente_proveedor_rut: rutCliente === null ? 0 : this.rutService.QuitarDV(rutCliente),
        folio: nroDoc === null ? 0 : nroDoc,
        recorrido_codigo: listaRecorridos,
        listaTipoDocumento: listaTipoDoc,
        listaVendedor,
        listaComunas,
      },
      orden_envio: this.formHeader.get('orden_envio').value,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };
    this.currentPayload = inputParams;
    this.docSeleccionado = 0;
    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.listaMovimientos = null;
    this.listaMovimientosAll = null;

    this.documentoService.obtenerDocumentoCSRecorrido(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros } = respuesta;
      this.listaMovimientosAll = registros;
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = pageNumber;
      this.listaMovimientosAll.forEach((mov, index) => {
        mov.additionalInfo = {};
        mov.rutFormato = this.rutService.AgregarDV(mov.cliente_proveedor_rut);
        mov.additionalInfo.index = index;
        mov.seleccion = false;
        mov.loadingPdf = false;
      });

      this.optionsComunas = [];
      let sel2: any;
      let listaComunaDocumentoDistinct = this.listaMovimientosAll.filter((thing, i, arr) => arr.findIndex((t) => t.comuna_facturacion === thing.comuna_facturacion) === i);
      listaComunaDocumentoDistinct.forEach((element) => {
        sel2 = { value: element.comuna_codigo_facturacion, label: element.comuna_facturacion };
        this.optionsComunas.push(sel2);
      });

      this.showPage(this.paginationContext.CurrentPage);
      this.loading = false;
      this.checkAllChangeStart({ checked: true });
    });
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  downloadExcelPdf({ tipo_dte_codigo, folio, id_lsoft }) {
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        tipo_dte_codigo,
        folio,
        id_lsoft,
      },
    };
    //delete inputParams.cantidadRegistrosPorPagina
    //delete inputParams.paginaActual

    //inputParams.entidad.retornaExcel = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams));
    const docIndex: number = this.listaMovimientosAll.findIndex((doc) => doc.id_lsoft === id_lsoft);
    const doc: any = this.listaMovimientosAll[docIndex];
    doc.loadingPdf = true;
    this.documentoService.obtenerPDFDocumento(inputParams, ({ mensajes, respuesta }) => {
      doc.loadingPdf = false;
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showInfoMessages(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo);
    });
  }

  showImprimirFacturaDetalle(documento) {
    this.modalSeleccionarImprimirFacturaDetalle.loadAndShow(documento);
  }

  openModalSeleccionarcliente() {
    this.modalSeleccionarCliente.show();
  }

  onClienteSeleccionado({ data, origen }) {
    this.cliente = data;
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut);
    this.formHeader.get('rutCliente').setValue(this.cliente.rutFormato);
  }

  onClienteNoEncontrado() {
    this.cliente = null;
  }

  checkAllChange({ checked }) {
    this.listaMovimientosAll.forEach((mov) => {
      mov.seleccion = checked;
      mov.additionalInfo.checked = checked;
    });
    this.listaMovimientos.forEach((mov) => {
      mov.seleccion = checked;
      mov.additionalInfo.checked = checked;
    });
    this.docSeleccionado = 0;
    this.cantidadSeleccionada();
  }

  checkAllChangeStart({ checked }) {
    this.listaMovimientosAll.forEach((mov) => {
      if (mov.impresion_doc == false) {
        mov.seleccion = checked;
        mov.additionalInfo.checked = checked;
      }
    });
    this.listaMovimientos.forEach((mov) => {
      if (mov.impresion_doc == false) {
        mov.seleccion = checked;
        mov.additionalInfo.checked = checked;
      }
    });
    this.docSeleccionado = 0;
    this.cantidadSeleccionada();
  }

  checkDetalle({ index, checked }) {
    const selectedMain: any = this.listaMovimientosAll.filter((p) => p.additionalInfo.index === index)[0];
    selectedMain.seleccion = !checked;
    selectedMain.additionalInfo.checked = !checked;

    const selected = this.listaMovimientos.filter((p) => p.additionalInfo.index === index)[0];
    selected.seleccion = !checked;
    selected.additionalInfo.checked = !checked;
    this.docSeleccionado = 0;
    this.cantidadSeleccionada();
  }

  enviarDocumentos() {
    const selected = _.cloneDeep(this.listaMovimientosAll).filter((mov) => mov.seleccion);
    if (selected.length === 0) {
      this.toastService.error('Seleccione registro(s)');
      return;
    }

    selected.forEach((mov) => {
      delete mov.additionalInfo;
      delete mov.__typename;
      delete mov.comuna_codigo_facturacion;
      delete mov.rutFormato;
      delete mov.loadingPdf;
    });

    const { documento, copia_cedible, enviar_pdf, enviar_xml, orden_envio } = this.formHeader.value;
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      documento,
      copia_cedible,
      enviar_pdf,
      enviar_xml,
      orden_envio,
      listaDocumento: selected,
      rut_usuario: this.rutUsuario,
    };
    this.processing = true;
    this.log('inputParams', JSON.stringify(inputParams));

    this.documentoService.imprimirFactura(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.processing = false;
        return;
      }

      // const { registros, totalPaginas, totalRegistros } = respuesta
      // const index: string = this.depositoDocumentoService.guardarPayload({ registros, totalPaginas, totalRegistros })
      this.processing = false;
      this.toastService.success('Operación exitosa');
      this.listaMovimientosAll.forEach((mov) => {
        mov.seleccion = false;
        mov.additionalInfo.checked = false;
      });
      this.listaMovimientos.forEach((mov) => {
        mov.seleccion = false;
        mov.additionalInfo.checked = false;
      });
      this.docSeleccionado = 0;
      // this.router.navigate(['/finanzas/destinoDeposito', index])
      this.modalSeleccionarImprimirFacturaResultado.loadAndShow(respuesta);
      this.buscar(this.paginationContext.CurrentPage);
    });
  }

  cantidadSeleccionada() {
    let cont = 1;
    this.listaMovimientosAll.forEach((mov) => {
      if (mov.seleccion === true) {
        this.docSeleccionado = cont;
        cont++;
      }
    });
  }

  LimpiarData() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader.reset();
    this.cliente = null;
    this.formHeader.get('fechaDesde').setValue(currentDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
    this.formHeader.get('orden_envio').setValue(0);
  }
}
